module.exports = __webpack_public_path__ + "img/tooFacedPal1.4e7550cd.jpg";